// extracted by mini-css-extract-plugin
module.exports = {"outerGrid":"CategoriezedLayout_outerGrid__2_kae","innerGrid":"CategoriezedLayout_innerGrid__2xYZf","categoryLabel":"CategoriezedLayout_categoryLabel__3ICMm"};